import { useCallback, useEffect, useState } from "react";

import { getMenuAliases } from "services/aliases/rest";
import { MenuAliasDto } from "services/aliases/restModels";

export interface UseMenuAliasesResult {
    aliases: MenuAliasDto[];
    loading: boolean;
    error: boolean;
    setAliases: (aliases: MenuAliasDto[]) => void;
    refetch: () => void;
}

/*
* Ссылки живут отдельно от настроек меню: они сохраняются сразу, а не по кнопке
* «Сохранить». setAliases — чтобы положить список, который вернула мутация,
* и не делать лишний запрос.
* */
export const useMenuAliases = (menuId: number): UseMenuAliasesResult => {
    const [aliases, setAliases] = useState<MenuAliasDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // ignore-флаг: поздний ответ по старому menuId не перезапишет свежий.
        let ignore = false;

        setLoading(true);
        setError(false);

        getMenuAliases(menuId)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setAliases(result);
                } else {
                    setError(true);
                    setAliases([]);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setAliases([]);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, reloadKey]);

    return { aliases, loading, error, setAliases, refetch };
};
